import { DeBetterDocNoResultBanner } from "@/modules/patients/detail/better-doc/de/components/de-better-doc-no-result-banner"
import { DeBetterDocRecommendedCareProviders } from "@/modules/patients/detail/better-doc/de/components/de-better-doc-recommended-care-providers"
import type { DeProgressNoteBetterDocResult } from "@/modules/patients/detail/better-doc/types"

type DeBetterDocResultProps = {
  betterDocResult: DeProgressNoteBetterDocResult | null
}

export const DeBetterDocResult = ({ betterDocResult }: DeBetterDocResultProps) => {
  if (betterDocResult?.kind === "CARE_PROVIDERS_RECOMMENDED") {
    return (
      <DeBetterDocRecommendedCareProviders
        key={betterDocResult.sessionId}
        recommendedCareProviders={betterDocResult.recommendedCareProviders}
      />
    )
  }

  if (betterDocResult?.kind === "NO_RESULT") {
    return <DeBetterDocNoResultBanner />
  }

  return null
}
